import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {Button,Row, Col, Input} from "reactstrap";

const ProgramFilter = ({onClickFilterCallback}) => {
  const [keyword, setKeyword] = React.useState('')
  const onProgramPhaseChange = (e) => {
    setKeyword( e.target.value)
  }
  const onClickFilter = (event,reset = false) => {
    event.preventDefault();
    if( reset ) {
      setKeyword('');
      onClickFilterCallback('', '', '')
    } else {
      onClickFilterCallback('', keyword, '')
    }
  }
  
  return (<form className="form__form-group" onSubmit={onClickFilter}>
    <Row>
      <Col md="4" >
        <p className="">Keyword</p>
        <div>
          <Input 
            type="text" 
            placeholder="Program phrase" 
            value={keyword}
            onChange={onProgramPhaseChange} 
          />
        </div>
      </Col>
      <Col md="4">
        <p className="">&nbsp;</p>
        <div className='flex filter-btns'>
          <Button
            type='submit'
            className="btn btn-sm btn-primary"
            color="#ffffff"
          >
            Filter
          </Button>
          <Button
            onClick={(e)=>onClickFilter(e,true)}
            className="btn btn-sm btn-secondary"
            color="#ffffff"
          >
            Reset
          </Button>
        </div>
      </Col>
    </Row>
  </form>)
}

ProgramFilter.propTypes = {
  onClickFilterCallback: PropTypes.func.isRequired,
};

export default connect((state) => ({
  auth: state.auth
}))(ProgramFilter);